import type { CoverLetterDocumentType } from '@xing-com/crate-lebenslauf-shared-client-document-variable';

import { PROFESSIONAL_INFORMATION_DEFAULTS } from '../const';
import { updateLocalStorage } from './updateLocalStorage';

export const addProfessionalInformationFields = (
  doc: CoverLetterDocumentType
): void => {
  const professionalExperience = [
    ...(doc.professionalExperience ?? []),
    PROFESSIONAL_INFORMATION_DEFAULTS,
  ];

  updateLocalStorage(`professionalExperience`, professionalExperience);
};
